<template>
  <page-listado>
    <page-header title="Factores de complejidad de proyecto">
      <b-button variant="primary" size="sm" to="/complejidadesProyecto/crear">
        <v-icon name="plus" width="16" />
        Crear factor de complejidad
      </b-button>
    </page-header>
    <tabla :complejidades-proyecto="complejidadesProyecto" />
  </page-listado>
</template>

<script>
import api from "@/services/complejidadesProyecto.js";
import Tabla from "./TablaComplejidadesProyecto.vue";
export default {
  components: { Tabla },
  data() {
    return {
      complejidadesProyecto: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return api.listar(this.$route.query).then((complejidadesProyecto) => {
        this.complejidadesProyecto = complejidadesProyecto;
      });
    },
  },
};
</script>
